<template>
    <Layout id="authenticated">
        <Sider
            v-model="isSiderCollapsed"
            theme="light"
            :trigger="null"
            collapsible
        >
            <div class="p-4 soft-border-right">
                <div
                    class="flex flex-col items-center justify-center font-bold bg-gray-100 logo"
                >
                    {{ title }}
                    <!-- --antd-wave-shadow-color css property randomly found on HTML -->
                    <!-- Since it is the same as the primary color, we use as text color  -->
                    <small
                        v-if="$theme !== 'normal'"
                        class="uppercase"
                        style="color: var(--antd-wave-shadow-color)"
                        v-text="$theme"
                    />
                </div>
            </div>
            <Menu
                mode="inline"
                :default-selected-keys="[currentResourceName]"
            >
                <Item
                    v-for="resource of resources"
                    :key="resource"
                    @click="$router.push({name: resource})"
                >
                    <Icon :type="$t(`icons.${resource}`)" />
                    <span>{{ $t(resource) }}</span>
                </Item>
            </Menu>
        </Sider>
        <Layout>
            <Header
                class="flex justify-between p-0 bg-white"
            >
                <div class="flex flew-row">
                    <Icon
                        class="trigger soft-border-right"
                        :type="triggerIcon"
                        @click="toggleSider"
                    />
                    <Breadcrumb />
                </div>
                <div class="flex flew-row">
                    <PortalTarget
                        class="mx-6 header-actions"
                        name="header-actions"
                    />
                    <Icon
                        class="px-4 trigger md:px-6 soft-border-left"
                        type="logout"
                        @click="logout"
                    />
                </div>
            </Header>
            <Content class="m-4">
                <slot />
            </Content>
        </Layout>
    </Layout>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import { Layout, Menu, Icon } from 'ant-design-vue';
import { mapState, mapActions } from 'vuex';

const { Sider, Header, Content } = Layout;
const { Item } = Menu;
export default {
    name: 'Authenticated',
    components: {
        Layout,
        Header,
        Sider,
        Menu,
        Item,
        Icon,
        Content,
        Breadcrumb,
    },
    data: () => ({
        resources: ['measures', 'customers'],
        title: null,
    }),
    computed: {
        ...mapState({
            isSiderCollapsed: ({ layout: { isSiderCollapsed } }) => isSiderCollapsed,
        }),
        currentResourceName() {
            return this.$route.name.split('.')[0];
        },
        triggerIcon() {
            return this.isSiderCollapsed
                ? 'menu-unfold'
                : 'menu-fold';
        },
    },
    watch: {
        // Toggle the title when collapsing the sider
        isSiderCollapsed() {
            // Wait for 50ms to make sure the title fits
            setTimeout(this.toggleTitle, 50);
        },
    },
    created() {
        this.toggleTitle();
    },
    methods: {
        ...mapActions({
            toggleSider: 'layout/toggleSider',
            logout: 'auth/logout',
        }),
        toggleTitle() {
            this.title = this.isSiderCollapsed
                ? 'IMS'
                : 'DFAC-IMS';
        },
    },
};
</script>
<style lang="scss" scoped>
#authenticated {
    .ant-layout {
        min-height: 100vh;
    }
    .ant-layout-content {
        flex: initial;
    }
    .trigger {
        font-size: 18px;
        line-height: 64px;
        padding: 0 24px;
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
            color: #1890ff;
        }
    }

    .logo {
        height: 32px;
    }

    $sides: left right;

    @each $side in $sides {
        .soft-border-#{$side} {
            border-#{$side}: 1px solid rgb(226, 232, 240);
        }
    }
}
</style>
